










































































































import Vue from "vue";
import Component from "vue-class-component";
import Divider from "../../components/common/Divider.vue";
import PreFooter from "../../components/common/PreFooter.vue";

@Component({
  components: {
    Divider,
    PreFooter
  }
})
export default class Courses extends Vue {
  private mounted(): void {
    window.scrollTo(0, 0);
  }
}
